import React from "react";
import { DisabledPrompt } from "bcms-react";
import { TableBody, TableColumnContainer, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { SVGAsset } from "res";
import ACHTransfersToTableRow from "components/shared/widgets/ACHWidgets/ACHTransfersToTableRow";
import { NoEntriesTableRow } from "components/shared/views/TableView/components/NoEntriesTableRow";

import "./styles.css";

/**
 * @function ACHTransfersToTable
 * @return {React.Component}
 * @exported true
 * @description - This is the "One Time ACH To"  main table view for the OneTimeACHPaymentPage.
 */
export default function ACHTransfersToTable(props) {
    const achToParticipants = props.achToParticipants ?? {};
    const onACHToParticipantChange = props.onACHToParticipantChange ?? (() => {});
    const onACHToParticipantDelete = props.onACHToParticipantDelete ?? (() => {});
    const showHoldPrenoteDistributionColumns = props.showHoldPrenoteDistributionColumns ?? false;

    const rows = achToParticipants.participants.reduce((acc, item) => {
        acc.push(
            <ACHTransfersToTableRow key={ item.id } achToParticipant={ item } onACHToParticipantChange={ onACHToParticipantChange }
            dataPoint={ `ACH_Transfers_To_Row_${ item.id }` } 
            onACHToParticipantDelete={ onACHToParticipantDelete } showHoldPrenoteDistributionColumns={ showHoldPrenoteDistributionColumns } />
        );
        return acc;
    }, []);
    const hasRows = rows.length > 0;
 
    return (
        <TableView className="one-time-ach-to-table">
            <TableColumnContainer className="one-time-ach-to-header">
                <TableItemView lassName="nickname-col" >
                    <span className="flex-container align-center">
                        <span className="set-width">Nickname</span>
                        <DisabledPrompt>
                            <SVGAsset id="SortIcon" className="sort-icon clickable" />
                        </DisabledPrompt>
                    </span>
                </TableItemView>
                <TableItemTextView className="notify-col" text="Notify" />
                <TableItemView lassName="unique-identifier-col" >
                    <span className="flex-container align-center">
                        <span className="set-width">Unique Identifier</span>
                        <DisabledPrompt>
                            <SVGAsset id="SortIcon" className="sort-icon clickable" />
                        </DisabledPrompt>
                    </span>
                </TableItemView>
                <TableItemTextView className="account-number-col" text="Account Number" />
                <TableItemView lassName="account-type-col" >
                    <span className="flex-container align-center">
                        <span className="set-width">Account Type</span>
                        <DisabledPrompt>
                            <SVGAsset id="SortIcon" className="sort-icon clickable" />
                        </DisabledPrompt>
                    </span>
                </TableItemView>
                { showHoldPrenoteDistributionColumns && 
                <>
                    <TableItemTextView className="hold-col" text="Hold" />
                    <TableItemTextView className="prenote-col" text="Prenote" />
                </>
                }
                <TableItemTextView className="amount-col" text="Amount" />
                { showHoldPrenoteDistributionColumns && 
                <TableItemTextView className="distributions-col" text={ "" } />
                }
                <TableItemTextView className="addenda-col" />
                <TableItemTextView className="actions-col" />
            </TableColumnContainer>
            <TableBody>
               { hasRows && rows }
               { !hasRows && <NoEntriesTableRow colSpan={8}/> }
            </TableBody>
        </TableView>
    )
}
